import React from 'react';
import { connect } from 'react-redux';

import { closeClotureDialog } from 'store/common/commonActions';
import { cloturer } from 'store/reclamation/reclamationsActions';

import { fetchReclamationCausesPrincipales } from 'utils/fetchers';
import { fetchReclamationMotifsResolution } from 'utils/fetchers';

import ClotureDialog from './ClotureDialog';

import { CausePrincipaleCodes } from 'constants.js';
import { GroupeTraitementCodes } from 'constants.js';
import { MotifResolutionCodes } from 'constants.js';

const Namespace = 'clotureReclamation';

class ClotureDialogContainer extends React.Component {
    constructor(props) {
        super(props);

        // Initialisation du state.
        this.state = this.getInitialState([]);
    }

    getInitialState = (motifsResolutionEtMessage, causesPrincipales) => {
        const initialState = {
            cloture: {
                motifResolutionId: 0,
                causePrincipaleId: 0,
                causePrincipaleDetailId: 0,
                utilisateurFautifId: 0,
                commentaire: '',
                mailAutomatique: '',
                fichiersIds: [],
                notifierSupport: false
            },
            formErrors: [],
            canCloture: false,
            motifsResolutionEtMessage: motifsResolutionEtMessage,
            causesPrincipales: causesPrincipales
        };

        return initialState;
    }


    async componentDidUpdate(prevProps) {

        const { reclamationId, open } = this.props;

        // A l'ouverture
        if (open && !prevProps.open) {


            var motifsResolutionEtMessage = await this.props.fetchReclamationMotifsResolution(reclamationId);
            var causesPrincipales = await this.props.fetchReclamationCausesPrincipales(reclamationId);

            this.setState(this.getInitialState(motifsResolutionEtMessage, causesPrincipales));
        }
    }



    handleClose = () => {
        const { onClose } = this.props;
        const { motifsResolutionEtMessage, causesPrincipales } = this.state;

        onClose();

        this.setState(this.getInitialState(motifsResolutionEtMessage, causesPrincipales));
    }

    handleClickSave = () => {
        const { cloturer, reclamationId } = this.props;
        const { cloture, motifsResolutionEtMessage, causesPrincipales } = this.state;

        // On passe le code au lieu de l'id.
        const clotureData = {
            motifResolutionCode: motifsResolutionEtMessage.motifsResolution.find(x => x.id === cloture.motifResolutionId).code,
            causePrincipaleCode: causesPrincipales.find(x => x.id === cloture.causePrincipaleId).code,
            causePrincipaleDetailId: cloture.causePrincipaleDetailId,
            utilisateurFautifId: cloture.utilisateurFautifId,
            commentaire: cloture.commentaire,
            mailAutomatique: cloture.mailAutomatique,
            fichiersIds: cloture.fichiersIds,
            notifierSupport: cloture.notifierSupport
        };

        cloturer(reclamationId, clotureData).then(() => { this.setState(this.getInitialState(motifsResolutionEtMessage, causesPrincipales)); });
    }

    checkErrors(errors) {
        // On check les erreurs.
        let clotureErrors = Array.from(this.state.formErrors);

        if (errors !== null) {
            errors.forEach(function (error) {
                if (error.errorMsg === null) {
                    // Si une erreur est présente pour le contrôle, on la supprime.
                    clotureErrors = clotureErrors.filter(e => e.key !== error.key);
                } else {
                    if (!clotureErrors.find(e => e.key === error.key)) {
                        clotureErrors.push(error);
                    }
                }
            });
        }

        return clotureErrors;
    }


    handleChangeMotifResolution = (event, errors) => {
        const { reclamationId } = this.props;
        const { motifsResolutionEtMessage } = this.state;
        let cloture = { ...this.state.cloture };

        const value = event.target.value;

        // Gestion du texte automatique du mail.
        let mailAutomatique = '';

        const motifResolution = motifsResolutionEtMessage.motifsResolution.find(x => x.id === value);
        if (motifResolution !== undefined) {
            switch (motifResolution.code) {
                case MotifResolutionCodes.RenvoiMarchandiseFacture:
                    mailAutomatique = `Suite à la déclaration d'incident numéro ${reclamationId}, nous vous informons que nous avons fait réexpédier les références concernées sous la référence commande B..........\r\n\r\nNous espérons avoir répondu à vos attentes. Si tel n'est pas le cas, nous vous invitons à reprendre contact avec votre technico-commercial sédentaire en lui indiquant le n° d'incident ci-dessus.`;
                    break;
                case MotifResolutionCodes.RenvoiMarchandiseNonFacture:
                    mailAutomatique = `Suite à la déclaration d'incident numéro ${reclamationId}, nous vous informons que nous avons fait réexpédier les références concernées sous la référence commande B..........\r\n\r\nNous espérons avoir répondu à vos attentes. Si tel n’est pas le cas, nous vous invitons à reprendre contact avec votre technico-commercial sédentaire en lui indiquant le n° d’incident ci-dessus.`;
                    break;
                case MotifResolutionCodes.AvoirClientSansRetour:
                    mailAutomatique = `Suite à la déclaration d'incident numéro ${reclamationId}, nous vous informons de la réalisation d’un avoir N°.......... d’un montant de .....€ TTC.\r\n\r\nNous espérons avoir répondu à vos attentes. Si tel n’est pas le cas, nous vous invitons à reprendre contact avec votre technico-commercial sédentaire en lui indiquant le n° d’incident ci-dessus.`;
                    break;
                case MotifResolutionCodes.ConditionsNonRemplies:
                    mailAutomatique = `Nous vous informons de la clôture de l'incident ${reclamationId}. En effet, après étude des éléments en notre possession, nous sommes dans l’impossibilité de donner une suite favorable à votre demande.\r\n\r\nPour toute information complémentaire sur ce dossier, nous vous invitons à reprendre contact avec votre technico-commercial sédentaire en lui indiquant le n° d’incident ci-dessus.`;
                    break;
                default: {
                    break;
                }
            }
        }

        cloture.motifResolutionId = value;
        cloture.mailAutomatique = mailAutomatique;

        // Si le motif de résolution n'est pas "Avoir client sans retour" on force la notification à "false"
        let motifAvoirClientSansRetour = motifsResolutionEtMessage.motifsResolution.find(e => e.code === MotifResolutionCodes.AvoirClientSansRetour);
        if (!motifAvoirClientSansRetour || motifAvoirClientSansRetour.id !== motifResolution.id) {
            cloture.notifierSupport = false;
        }

        const clotureErrors = this.checkErrors(errors);

        const canCloture = clotureErrors.length === 0;

        this.setState({ cloture, formErrors: clotureErrors, canCloture });
    }

    handleChange = (event, errors) => {
        let cloture = { ...this.state.cloture };

        const name = event.target.name;
        const value = event.target.value;

        // On met à jour la valeur dans la clôture.
        cloture[name] = value;

        const clotureErrors = this.checkErrors(errors);

        const canCloture = clotureErrors.length === 0;

        this.setState({ cloture, formErrors: clotureErrors, canCloture });
    }

    handleChangeCausePrincipale = (event, errors) => {
        const { causesPrincipales } = this.state;


        let cloture = { ...this.state.cloture };
        const value = event.target.value;


        // Gestion du texte du mémo
        let commentaire = '';

        const causePrincipale = causesPrincipales.find(x => x.id === value);
        if (causePrincipale !== undefined) {
            switch (causePrincipale.code) {
                case CausePrincipaleCodes.ArbitrageCommerce:
                    commentaire = `Au vu des éléments fournis, nous ne pouvons pas prendre de décision. Merci de vous adresser à votre commercial pour prise de position.`;
                    break;
                default: {
                    break;
                }
            }
        }

        cloture.causePrincipaleId = value;
        cloture.causePrincipaleDetailId = 0;
        cloture.commentaire = commentaire;

        // On check les erreurs.
        const clotureErrors = this.checkErrors(errors);

        const canCloture = clotureErrors.length === 0;

        this.setState({ cloture, formErrors: clotureErrors, canCloture });
    }

    handleChangeUtilisateur = (id, codePO, nom, prenom, errors) => {
        let cloture = { ...this.state.cloture };

        cloture.UtilisateurFautifId = id;

        // On check les erreurs.
        const clotureErrors = this.checkErrors(errors);

        const canCloture = clotureErrors.length === 0;

        this.setState({ cloture, formErrors: clotureErrors, canCloture });
    }

    handleNotifierSupport = (value) => {
        this.setState({
            cloture: {
                ...this.state.cloture,
                notifierSupport: value
            }
        });
    }

    render() {
        const { open, reclamationId, isQualiteEntrepot } = this.props;
        const { cloture, formErrors, canCloture, motifsResolutionEtMessage, causesPrincipales } = this.state;

        if (!open || !motifsResolutionEtMessage || !motifsResolutionEtMessage.motifsResolution || motifsResolutionEtMessage.motifsResolution.length === 0 || !causesPrincipales || causesPrincipales.length === 0) {
            return null;
        }

        let causePrincipale = causesPrincipales.find(x => x.id === cloture.causePrincipaleId);
        let causePrincipaleDetails = causePrincipale ? causePrincipale.details : null;

        return (
            <ClotureDialog
                onClose={this.handleClose}
                reclamationId={reclamationId}
                cloture={cloture}
                onChange={this.handleChange}
                onMotifResolutionChange={this.handleChangeMotifResolution}
                onCausePrincipaleChange={this.handleChangeCausePrincipale}
                onUtilisateurChange={this.handleChangeUtilisateur}
                onClickSave={this.handleClickSave}
                validationErrors={formErrors}
                canCloture={canCloture}
                namespace={Namespace}
                motifsResolution={motifsResolutionEtMessage.motifsResolution}
                motifsResolutionMessage={motifsResolutionEtMessage.message}
                causesPrincipales={causesPrincipales}
                causePrincipaleDetails={causePrincipaleDetails}
                onNotifierSupport={this.handleNotifierSupport}
                isQualiteEntrepot={isQualiteEntrepot}
            />
        );
    }
}

const mapStateToProps = state => {

    let open = state.common.clotureDialogOpen;
    let reclamationId = state.common.cloture.reclamationId;

    let isQualiteEntrepot = false;
    const groupes = state.groupe.groupes.items;

    if (groupes.length > 0) {

        const groupeQualiteEntrepot = groupes.find(x => x.code === GroupeTraitementCodes.QualiteEntrepot);
        const dossierGroupeId = state.reclamation.details.item.affectationGroupe.id;

        if (groupeQualiteEntrepot !== undefined && dossierGroupeId > 0) {
            isQualiteEntrepot = groupeQualiteEntrepot.id === dossierGroupeId;
        }
    }

    return {
        open: open,
        reclamationId: reclamationId,
        isQualiteEntrepot: isQualiteEntrepot
    }
};


const mapDispatchToProps = dispatch => ({
    cloturer: (reclamationId, cloture) => dispatch(cloturer(reclamationId, cloture)),
    onClose: () => dispatch(closeClotureDialog()),
    fetchReclamationMotifsResolution: (reclamationId) => dispatch(fetchReclamationMotifsResolution(reclamationId)),
    fetchReclamationCausesPrincipales: (reclamationId) => dispatch(fetchReclamationCausesPrincipales(reclamationId))
});


export default connect(mapStateToProps, mapDispatchToProps)(ClotureDialogContainer);